import React from'react';import PropTypes from'prop-types';import {useIntl}from'react-intl';import styled from'styled-components';import {LANG}from'@manulife/mux';import {ManulifeFr,Manulife}from'@manulife/mux-logos';import useCoBranding from'../../hooks/useCoBranding.js';var CoBrandingLogoWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CoBrandingLogo__CoBrandingLogoWrapper",
  componentId: "sc-1ybgx7m-0"
})(["display:flex;flex-direction:row;align-items:center;padding-top:8px;padding-bottom:8px;background-color:#ffffff;"]);
var LogoWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CoBrandingLogo__LogoWrapper",
  componentId: "sc-1ybgx7m-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;height:64px;margin:0 0 0 32px;"]);
var Separator = /*#__PURE__*/styled.div.withConfig({
  displayName: "CoBrandingLogo__Separator",
  componentId: "sc-1ybgx7m-2"
})(["width:1px;height:100%;margin:0 32px;background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.dark.shade_dark_1;
});
var BrandingImage = /*#__PURE__*/styled.div.withConfig({
  displayName: "CoBrandingLogo__BrandingImage",
  componentId: "sc-1ybgx7m-3"
})(["background-image:url(", ");width:69px;height:64px;background-size:contain;background-position:left;background-repeat:no-repeat;position:relative;"], function (props) {
  return props.src;
});
var BrandName = /*#__PURE__*/styled.div.withConfig({
  displayName: "CoBrandingLogo__BrandName",
  componentId: "sc-1ybgx7m-4"
})(["font-size:1.5rem;font-weight:600;margin-left:1rem;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
});
function CoBrandingLogo(props) {
  var _coBranding$brand, _coBranding$brand2;
  var hideManulife = props.hideManulife,
    hideCoBrand = props.hideCoBrand;
  var coBranding = useCoBranding();
  var intl = useIntl();
  var ManulifeLogo = intl.locale === LANG.FR_CA ? ManulifeFr : Manulife;
  var showCoBrandLogo = !hideCoBrand && Boolean(coBranding === null || coBranding === void 0 ? void 0 : (_coBranding$brand = coBranding.brand) === null || _coBranding$brand === void 0 ? void 0 : _coBranding$brand.logoUrl);
  var showCoBrandName = !hideCoBrand && Boolean(coBranding === null || coBranding === void 0 ? void 0 : (_coBranding$brand2 = coBranding.brand) === null || _coBranding$brand2 === void 0 ? void 0 : _coBranding$brand2.name) && !(coBranding !== null && coBranding !== void 0 && coBranding.hideCoBrandName);
  if (hideManulife && !showCoBrandLogo) {
    return null;
  }
  return /*#__PURE__*/React.createElement(CoBrandingLogoWrapper, null, /*#__PURE__*/React.createElement(LogoWrapper, null, !hideManulife && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ManulifeLogo.WORDMARK_BLACK, {
    role: "img",
    width: 69,
    height: 19,
    "aria-label": intl.formatMessage({
      id: 'shared.global.manulife'
    })
  }), showCoBrandLogo && /*#__PURE__*/React.createElement(Separator, null)), showCoBrandLogo && /*#__PURE__*/React.createElement(BrandingImage, {
    src: coBranding.brand.logoUrl,
    role: "img",
    "aria-label": coBranding.brand.name
  })), showCoBrandName && /*#__PURE__*/React.createElement(BrandName, null, coBranding.brand.name));
}
process.env.NODE_ENV !== "production" ? CoBrandingLogo.propTypes = {
  hideManulife: PropTypes.bool,
  hideCoBrand: PropTypes.bool
} : void 0;
CoBrandingLogo.defaultProps = {
  hideManulife: false,
  hideCoBrand: false
};export{CoBrandingLogo as default};